import { JSX, ReactNode } from 'react'
import { Portal, Toast, Toaster, Stack, createToaster } from '@chakra-ui/react'

import * as detective from '@/lib/detective.js'




export const toaster = createToaster(
	{ placement: 'bottom-end' },

)


export function success (title?: ReactNode, description?: ReactNode): void
{
	toaster.create(
		{
			type: 'success',

			title,
			description,

		},

	)

}


export function info (title?: ReactNode, description?: ReactNode): void
{
	toaster.create(
		{
			type: 'info',

			title,
			description,

		},

	)

}


export function warning (title?: ReactNode, description?: ReactNode): void
{
	toaster.create(
		{
			type: 'warning',

			title,
			description,

		},
	)

}


// eslint-disable-next-line id-denylist
export function error (e: Error): void
{
	toaster.create(
		{
			type: 'error',

			title      : e.name,
			description: e.message,

		},

	)

}




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Body
(
	props: {
		title?      : ReactNode
		description?: ReactNode

	},

)
:	JSX.Element
{
	let elem = []

	if (detective.is_exist(props.title) )
	{
		elem.push(
			<Toast.Title key="title">{props.title}</Toast.Title>,

		)

	}

	if (detective.is_exist(props.description) )
	{
		elem.push(
			<Toast.Description key="description">{props.description}</Toast.Description>,

		)

	}

	return (
		<Stack gap="0.5" flex="1" maxWidth="100%">
			{elem}

		</Stack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		title?      : ReactNode
		description?: ReactNode

	},

)
:	JSX.Element
{
	return (
		<Toast.Root width={{ md: 'sm' }}>
			<Toast.Indicator />

			<Body {...props} />

			<Toast.CloseTrigger />

		</Toast.Root>

	)


}


export default function (): JSX.Element
{
	return (
		<Portal>
			<Toaster toaster={toaster}>
				{ v => <Root title={v.title} description={v.description} /> }

			</Toaster>

		</Portal>


	)

}
